export function isMac() {
  if (navigator.userAgent && navigator.userAgent.indexOf('Mac') >= 0) {
    return true;
  }
}
